$(document).ready(function () {
  // Badges slider with text
  if ($(document).find(".badges-main-container").length > 0) {
    $(".badges-main-container").slick({
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      arrows: false,
      infinite: true,
      swipe: false,
      slidesToShow: 3.5,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false,
    });
  }
  if (window.matchMedia("(max-width: 900px)").matches) {
    // GUIDE BOOK
    if ($(document).find(".custom-blog-grid-items").length > 0) {
      $(".custom-blog-grid-items").slick({
        dots: true,
        infinite: true,
        arrows: false,
        centerPadding: "30px",
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
    // COLLECTION LIST
    if ($(document).find(".collection-list-wrapper  .collection-list").length > 0) {
      $(".collection-list-wrapper  .collection-list").slick({
        dots: true,
        infinite: true,
        arrows: false,
        centerPadding: "30px",
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
  }
  if (window.matchMedia("(max-width: 750px)").matches) {
    // TESTIMONIAL
    if ($(document).find(".custom_review_section .grid").length > 0) {
      $(".custom_review_section .grid").slick({
        dots: true,
        infinite: true,
        arrows: false,
        centerPadding: "30px",
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
  }
  // collection page banner slider js
  if ($(document).find(".main-banner-slider-collection-container").length > 0) {
    var swiper = new Swiper(".main-banner-slider-collection-container", {
       slidesPerView: 1,
        spaceBetween: 20,
      preventClicks :true,
  
      autoplay: {
       delay: 2000,
       disableOnInteraction: false,
     },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
  }
    // collection page vertical visible on condition
    if($('.facets-vertical').find('details').length <= 2){
       $('.facets-vertical').addClass("filternotavailabel");                        
    }
  
    // add quick add button in zoorix bundle app 
    if($(".product-main-details-and-video-container").children(".product-main-details-container").length == 0 && $(".product-main-details-and-video-container").children(".product-main-details-videos-grid").length == 1){
      $(".product-main-details-and-video").css({"background":"#fff","width":"100%"});
      $(".product-main-details-and-video").children(".product-main-details-videos-grid").css("width","100%");
      $(".product-main-details-and-video-container").children(".product-main-details-container").css("padding","0")
    }
    if($(".product-main-details-and-video-container").children(".product-main-details-container").length == 1 && $(".product-main-details-and-video-container").children(".product-main-details-videos-grid").length == 0){
        $(".product-main-details-and-video").css({"background":"#f7f7f7","width":"100%"});
        $(".product-main-details-and-video").children(".product-main-details-info").css("width","100%");
    }
  // product related faqs add icon
  
  $(".product-related-faq h3:not(:first-child)").prepend('	<svg width="20px" height="20px" viewBox="0 -0.5 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"/><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/><g id="SVGRepo_iconCarrier"> <title>plus [#a9a9a9]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-379.000000, -240.000000)" fill="#a9a9a9"> <g id="icons" transform="translate(56.000000, 160.000000)"> <polygon id="plus-[#a9a9a9]" points="344 89 344 91 334.55 91 334.55 100 332.45 100 332.45 91 323 91 323 89 332.45 89 332.45 80 334.55 80 334.55 89"> </polygon> </g> </g> </g> </g></svg>');


  // PRODUCT FAQ
  $(document).on("click",".product-related-faq h3:not(:first-child)",function() {
    $(this).next().slideToggle('xyz')
    $(this).next().toggleClass('accordion_active')
    $(this).toggleClass('accordion_active')
  });
  
  //---header mega menu
  if (window.matchMedia("(min-width: 1550px)").matches) {
    $(".header__inline-menu").addClass("page-width");
  }

  // PRODUCT THUMB IMAGE
  if (window.matchMedia('(min-width: 990px)').matches) {
   $('.rackupGoThumslider').removeClass('slider')
 }
  // remove empty span tags 
  $('.handle-product .product-metafields span').each(function() {
    const $this = $(this);
    if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
        $this.remove();
  });
  // remove empty p tags 
  // $('p').each(function() {
  //   const $this = $(this);
  //   if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
  //       $this.remove();
  // });
  // remove empty div
  $('.handle-product .product-primary-description div').each(function() {
    const $this = $(this);
    if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
        $this.remove();
  });
    $('div').filter(function() {
      
        if($(this).children().length === 1 && $(this).children('br').length === 1){
 
          $(this).css("display","none")
        }
        
    }) // Remove divs with only one <br> child

    $('h3').filter(function() {
        
          if($(this).children().length === 1 && $(this).children('br').length === 1){
            
            $(this).css("display","none")
          }
      }) 
    // add element after bundle loaded
    function BundleFun() {
        let bundleElement = $('#rbr-container-element-true');
            bundleElement.prepend('<h5 class="bundle-heading">Bundle Includes</h5>');
    }
    setTimeout(BundleFun, 2000);
  
  if($("body").hasClass("product") == true) {
      if(document.querySelectorAll('.itg_product_product__info-wrapper').length > 0){
         let cart_symbol = document.body.getAttribute('data-cartcurrency');
         let cusemail = document.body.getAttribute('data-cusemail');
         let country = document.body.getAttribute('data-country');
         let country_price = parseFloat(document.body.getAttribute('data-cprice'));
         let vid = $(document).find('.product-variant-id').val();
         let variantDetailId = $(document).find('.itg_'+vid).val();
         let check_continue = $(document).find('.itg_'+vid).attr('data-policy');
         if(check_continue == 'check_true'){
           $(document).find('.product-form__submit').removeAttr('disabled');
         }
         if(cusemail){
           if(variantDetailId){
              $(document).find('.itg_product_product__info-wrapper .main_meta_price').attr('name','properties[_Updateprice]');
              $(document).find('.itg_product_product__info-wrapper .custom_main_price').css("display", "none");
              $(document).find('.itg_product_product__info-wrapper .custom_main_login_price').css("display", "block");
              if(country == 'Canada'){
                let variantCanada = parseFloat(variantDetailId) * country_price;
                let canadaPrice = variantCanada.toFixed(2);
                $(document).find('.itg_product_product__info-wrapper .main_meta_price').val(canadaPrice);
                $(document).find('.itg_product_product__info-wrapper .custom_main_login_price span').text(cart_symbol+''+canadaPrice);
              }else{
                $(document).find('.itg_product_product__info-wrapper .main_meta_price').val(variantDetailId);
                $(document).find('.itg_product_product__info-wrapper .custom_main_login_price span').text(cart_symbol+''+variantDetailId);
              }
            }else{
              $(document).find('.itg_product_product__info-wrapper .main_meta_price').attr('name','');
              $(document).find('.itg_product_product__info-wrapper .main_meta_price').val('');
              $(document).find('.itg_product_product__info-wrapper .custom_main_price').css("display", "block");
              $(document).find('.itg_product_product__info-wrapper .custom_main_login_price').css("display", "none");
              $(document).find('.itg_product_product__info-wrapper .custom_main_login_price span').text('');
            }
         }else{
           if(variantDetailId){
               if(country == 'Canada'){
                  let variantCanada = parseFloat(variantDetailId) * country_price;
                  let canadaPrice = variantCanada.toFixed(2);
                  $(document).find('.itg_product_product__info-wrapper .login-after-pro-account span').text(cart_symbol+''+canadaPrice);
               }else{
                  $(document).find('.itg_product_product__info-wrapper .login-after-pro-account span').text(cart_symbol+''+variantDetailId);
               }
               $(document).find('.itg_product_product__info-wrapper .login-after-pro-account').css("display", "block");
            }else{
              $(document).find('.itg_product_product__info-wrapper .login-after-pro-account').css("display", "none");
              $(document).find('.itg_product_product__info-wrapper .login-after-pro-account span').text('');
            }
         }
      }
   }

  if($("body").hasClass("product") != true) {
     $(document).on("change",".product__info-container .select__select",function() {
            let thsdiv = $(this).closest('.product__info-container');
           setTimeout(function() {
             let cart_symbol = document.body.getAttribute('data-cartcurrency');
             let cusemail = document.body.getAttribute('data-cusemail');
             let country = document.body.getAttribute('data-country');
             let country_price = parseFloat(document.body.getAttribute('data-cprice'));
             let vid = thsdiv.find('.product-variant-id').val();
             let variantDetailId = thsdiv.find('.itg_'+vid).val();
             let check_continue = $(document).find('.itg_'+vid).attr('data-policy');
             if(check_continue == 'check_true'){
               $(document).find('.product-form__submit').removeAttr('disabled');
             }
             if(cusemail){
                if(variantDetailId){
                    thsdiv.find('.main_meta_price').attr('name','properties[_Updateprice]');
                    $(document).find('.custom_main_price').css("display", "none");
                    $(document).find('.custom_main_login_price').css("display", "block");
                    if(country == 'Canada'){
                      let variantCanada = parseFloat(variantDetailId) * country_price;
                      let canadaPrice = variantCanada.toFixed(2);
                      thsdiv.find('.main_meta_price').val(canadaPrice);
                      $(document).find('.custom_main_login_price span').text(cart_symbol+''+canadaPrice);
                    }else{
                      thsdiv.find('.main_meta_price').val(variantDetailId);
                      $(document).find('.custom_main_login_price span').text(cart_symbol+''+variantDetailId);
                    }
                }else{
                   thsdiv.find('.main_meta_price').attr('name','');
                   thsdiv.find('.main_meta_price').val('');
                   $(document).find('.custom_main_price').css("display", "block");
                   $(document).find('.custom_main_login_price').css("display", "none");
                   $(document).find('.custom_main_login_price span').text('');
                }
             }else{
                if(variantDetailId){
                  if(country == 'Canada'){
                      let variantCanada = parseFloat(variantDetailId) * country_price;
                      let canadaPrice = variantCanada.toFixed(2);
                      $(document).find('.login-after-pro-account span').text(cart_symbol+''+canadaPrice);
                    }else{
                      $(document).find('.login-after-pro-account span').text(cart_symbol+''+variantDetailId);
                    }
                    $(document).find('.login-after-pro-account').css("display", "block");
                }else{
                  $(document).find('.login-after-pro-account').css("display", "none");
                  $(document).find('.login-after-pro-account span').text('');
                }
             }
           }, 2000);
    });
  }
  
});
document.addEventListener("DOMContentLoaded", function() {
  if(document.querySelector('.product-specification') !== null){
    var productSpecSection = document.querySelector('.product-specification');
    
    // Select all tables inside the product-specification container
    var tables = productSpecSection.getElementsByTagName('table');
    
    // Loop through each table and remove inline styles
    for (var table of tables) {
      // Loop through all rows and cells in the table
      for (var row of table.rows) {
        for (var cell of row.cells) {
          // Remove the 'style' attribute from each cell
          cell.removeAttribute('style');
        }
      }
    }
  }
});



// document.addEventListener('DOMContentLoaded', function () {
//   function createHandle(title) {
//   return title
//     .toLowerCase()                      // Convert to lowercase
//     .replace(/\s+/g, '-')               // Replace spaces with hyphens
//     .replace(/[^\w\-]+/g, '')           // Remove all non-word chars
//     .replace(/\-\-+/g, '-')             // Replace multiple hyphens with a single hyphen
//     .replace(/^-+|-+$/g, '');           // Trim hyphens from the start and end
//   }
//   setTimeout(function notForSoldFun() {
//     let bundleProductGrid = document.querySelectorAll('.rbr-stn__bundleProducts__container');
//     let mainProductTitle = document.querySelector('.product__title h2');
//     let mainBundeProductTitle = document.querySelector('.rbr-standard-bundle__title span').innerText;
//     let mainProductButton = document.querySelector('.product-form__buttons');

//     // let titles = [];
//     console.log("Bundle Product Grid Count:", bundleProductGrid.length);

//     bundleProductGrid.forEach(function (gridItem) {
//       let innerItems = gridItem.querySelectorAll('.rbr-productNamePrice__title__container');

//       // console.log("Inner Items Count in Grid Item:", innerItems.length);
//       console.log(innerItems.innerHTML);
//       innerItems.forEach(function (titleContainer) {
        
//         if (titleContainer) {
//           // titles.push(titleContainer.textContent.trim());
//           let mainProductTitleValue = mainProductTitle.innerText.trim();
//           let bundleProductTitleValue = titleContainer.textContent.trim();
//           let mainBundeProductTitleValue = mainBundeProductTitle.trim();
//           // let mainBundeProductURL = encodeURIComponent(mainBundeProductTitleValue).replaceAll('%20','+');
//           if (bundleProductTitleValue == mainProductTitleValue) {
//             if (mainProductTitleValue != mainBundeProductTitleValue) {
//               let mainBundeProductHandle = createHandle(mainBundeProductTitle);
//               console.log(mainBundeProductHandle);
//               mainProductButton.innerHTML = `<a class='button button--secondary not-sold-seperatly' href='/products/${mainBundeProductHandle}'>Not sold Separately</a>`;
//             }
//           }
//         }
//       });
//     });
//     // console.log("Collected Titles:", titles);
//   }, 2000);
//   setTimeout(notForSoldFun,5000);
//   setTimeout(notForSoldFun,8000);
  
// });

document.addEventListener('click', function (event) {
  // Check if the clicked element has the class '.quick-add'
  if (event.target.closest('.quick-add')) {
    setTimeout(() => {
      const loader = document.querySelector('.quick-add-modal__content-info .custom-loader');
      const buttons = document.querySelector('.quick-add-modal__content-info .product-form__buttons');
      
      if (loader && buttons) {
        loader.style.display = 'none';  // Hide the loader
        buttons.style.display = 'block'; // Show the buttons
      }
    }, 4000); // 4 seconds delay
  }
});


document.addEventListener('DOMContentLoaded', function () {
  
  setTimeout( ()=>{
     document.querySelector('.custom-loader').style.display = 'none';
     document.querySelector('.product-form__buttons').style.display = 'flex'
    
  }, 4000)
  
     
  // function createHandle(title) {
  //   return title
  //     .toLowerCase()                      // Convert to lowercase
  //     .replace(/\s+/g, '-')               // Replace spaces with hyphens
  //     .replace(/[^\w\-]+/g, '')           // Remove all non-word chars
  //     .replace(/\-\-+/g, '-')             // Replace multiple hyphens with a single hyphen
  //     .replace(/^-+|-+$/g, '') 
  //     .replace(/-bundle/g, ''); // Trim hyphens from the start and end
  // }

  // function notForSoldFun() {
  //   let bundleProductGrid = document.querySelectorAll('.rbr-stn__bundleProducts__container');
  //   let mainProductTitle = document.querySelector('.product__title h2');
  //   let mainBundeProductTitle = document.querySelector('.rbr-standard-bundle__title span').innerText;
  //   let mainProductButton = document.querySelector('.product-form__buttons');

  //   console.log("Bundle Product Grid Count:", bundleProductGrid.length);
  // if(mainBundeProductTitle ){
   
  //   bundleProductGrid.forEach(function (gridItem) {
  //     let innerItems = gridItem.querySelectorAll('.rbr-productNamePrice__title__container');
      
  //     innerItems.forEach(function (titleContainer) {
        
  //       if (titleContainer) {
  //         let mainProductTitleValue = mainProductTitle.innerText.trim();
  //         let bundleProductTitleValue = titleContainer.textContent.trim();
  //         let mainBundeProductTitleValue = mainBundeProductTitle.trim();
  //         if(mainProductTitleValue == "EcoFlow 5kWh LFP Battery"){
  //           if (bundleProductTitleValue === mainProductTitleValue) {
  //             if (mainProductTitleValue !== mainBundeProductTitleValue) {
  //               let mainBundeProductHandle = createHandle(mainBundeProductTitle);
  //               console.log(mainBundeProductHandle);
  //               mainProductButton.innerHTML = `<a class='button button--secondary not-sold-separatly' href='/products/${mainBundeProductHandle}'>Not sold Separately</a>`;
           
  //             }
  //           }
  //         }
  //       }
  //     });
  //   });
  //  }
  // }
  
  // setTimeout(notForSoldFun, 2000);
  // setTimeout(notForSoldFun, 3000);
  // setTimeout(notForSoldFun, 5000);
  
});


